import styled from '@emotion/styled/macro';
import { em, padding } from 'polished';

export const TabsNavActions = styled.div({
  ...padding(0, em(6)),
  display: 'flex',
  justifyContent: 'space-around'
});
